import { CuriosityNamespace, CuriosityValue } from '@procureai/curiosity-ui-mui';

import { SearchRefinementListItem } from '../SearchRefinementListItem/SearchRefinementListItem.js';
import { SearchRefinementListItemProps } from '../SearchRefinementListItem/SearchRefinementListItem.types.js';

export interface SearchRefinementListItemCuriosityProps extends SearchRefinementListItemProps {
  ns: CuriosityNamespace;
}

export const SearchRefinementListItemCuriosity = ({ ns, ...otherProps }: SearchRefinementListItemCuriosityProps) => {
  return (
    <SearchRefinementListItem {...otherProps}>
      <CuriosityValue ns={ns} i18nKey={otherProps.item.label} />
    </SearchRefinementListItem>
  );
};
